// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/BG_common.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fToq30A2NjkBMOkDAC22 {
  height: calc(100vh - 61.25px);
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  margin-top: 61.25px;
  display: flex;
  flex-direction: column;
  transition: padding-left 250ms;
  justify-content: space-between;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}
@media screen and (min-width: 800px) {
  .fToq30A2NjkBMOkDAC22 {
    padding-left: 14rem;
  }
}
.fToq30A2NjkBMOkDAC22 .hero {
  background-color: #eef4f4;
}
.fToq30A2NjkBMOkDAC22::-webkit-scrollbar {
  width: 8px !important;
}
.fToq30A2NjkBMOkDAC22::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 5px;
}

@media screen and (min-width: 800px) {
  .WVXfcBt9I88sVt0whfcX {
    padding-left: 46px;
    transition: padding-left 250ms;
  }
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/components/AdminLayout/Layout.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,8BAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;AACF;AACE;EAdF;IAeI,mBAAA;EAEF;AACF;AAAE;EACE,yBAAA;AAEJ;AACE;EACE,qBAAA;AACJ;AACE;EACE,gBAAA;EACA,kBAAA;AACJ;;AAIE;EADF;IAEI,kBAAA;IACA,8BAAA;EAAF;AACF","sourceRoot":""}]);
// Exports
export var layout = `fToq30A2NjkBMOkDAC22`;
export var collapsed = `WVXfcBt9I88sVt0whfcX`;
export default ___CSS_LOADER_EXPORT___;
